import React from "react";
import { FolderSwitcher } from "./FolderRail";

// Search, date and Clear, plus the folder button below xl. Sticks to the top
// while the list scrolls.
//
// Opaque rather than translucent: rows are tall now that they carry a
// summary, and an expanded transcript scrolling behind a blur reads straight
// through it.
export function HistoryFilterBar({
  language,
  folderListProps,
  viewTitle,
  count,
  folderTitle,
  searchKeyword,
  onSearch,
  filterDate,
  onDate,
  hasFilters,
  onClear,
}) {
  return (
    <div className="sticky top-0 z-20 -mx-4 lg:-mx-8 px-4 lg:px-8 pt-3 pb-3 bg-slate-100 dark:bg-dashboard-bg">
      <div className="flex flex-col sm:flex-row gap-2 sm:gap-3 p-2.5 bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
        <FolderSwitcher {...folderListProps} viewTitle={viewTitle} count={count} />
        <div className="relative flex-1">
          <svg
            className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-4.35-4.35m1.35-5.65a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
          <input
            className="w-full pl-9 pr-9 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none text-sm transition"
            type="text"
            aria-label={language === "zh" ? "搜尋對話" : "Search conversations"}
            placeholder={
              folderTitle
                ? (language === "zh" ? `搜尋「${folderTitle}」...` : `Search ${folderTitle}...`)
                : (language === "zh" ? "搜尋所有對話..." : "Search all conversations...")
            }
            value={searchKeyword}
            onChange={(e) => onSearch(e.target.value)}
          />
          {searchKeyword && (
            <button
              className="absolute right-2 top-1/2 -translate-y-1/2 w-6 h-6 inline-flex items-center justify-center rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 dark:hover:text-gray-200 transition-colors"
              title={language === "zh" ? "清除搜尋" : "Clear search"}
              onClick={() => onSearch("")}
            >
              <svg
                className="w-3.5 h-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          )}
        </div>
        <input
          className="px-3 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 dark:[color-scheme:dark] focus:ring-2 focus:ring-orange-500 focus:border-transparent outline-none text-sm transition"
          type="date"
          aria-label={language === "zh" ? "對話日期" : "Conversation date"}
          value={filterDate}
          onChange={(e) => onDate(e.target.value)}
        />
        {hasFilters && (
          <button
            className="px-4 py-2 rounded-lg bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors font-medium text-sm"
            onClick={onClear}
          >
            {language === "zh" ? "清除" : "Clear"}
          </button>
        )}
      </div>
    </div>
  );
}
